export interface FanLayout { cardWidth:number; height:number; rows:number; cards:{slot:number;row:number;x:number;y:number;angle:number}[] }
/** Six per row on every device keeps slot rows identical for actor and watchers. */
export function layoutFan(count:number,width:number):FanLayout {
  if(!Number.isSafeInteger(count)||count<0)throw new Error('Invalid fan count');
  if(!count)return {cardWidth:88,height:0,rows:0,cards:[]};
  const rows=Math.ceil(count/6),rowCounts=Array.from({length:rows},(_,r)=>Math.floor(count/rows)+(r<count%rows?1:0));
  const cardWidth=(width<=400?88:100)-(rows>=3?10:0),cardHeight=cardWidth*1.5;
  const per=rowCounts[0]!,rowGap=rows>1?48:0;
  const step=per>1?Math.min(width<=400?52:62,Math.max(0,width-cardWidth-54)/(per-1)):0;
  const spread=per>1?Math.min(4.5,38/(per-1)):0;
  const base=rows===1?54:24,arc=rows===1?28:16;
  const jitter=(n:number)=>{const x=Math.sin(n*127.1)*43758.5453;return x-Math.floor(x)-.5;};
  const cards:FanLayout['cards']=[];
  rowCounts.forEach((n,row)=>{for(let i=0;i<n;i++){
    const slot=cards.length,offset=i-(n-1)/2,t=n>1?offset/((n-1)/2):0;
    cards.push({slot,row,x:offset*step,y:base+row*rowGap+t*t*arc+jitter(slot+50)*3,angle:offset*spread+jitter(slot)*1.2});
  }});
  return {cardWidth,height:Math.ceil(36+base+arc+(rows-1)*rowGap+cardHeight+18),rows,cards};
}
